import * as e from "react";
export function createContext(t, n) {
  const o = /*#__PURE__*/e.createContext(n);
  function r(t) {
    const {
        children: n,
        ...r
      } = t,
      c = e.useMemo(() => r, Object.values(r)); /*#__PURE__*/
    return e.createElement(o.Provider, {
      value: c
    }, n);
  }
  return r.displayName = t + "Provider", [r, function (r) {
    const c = e.useContext(o);
    if (c) return c;
    if (void 0 !== n) return n;
    throw new Error("`".concat(r, "` must be used within `").concat(t, "`"));
  }];
}
export function createContextScope(n) {
  let o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let r = [];
  const c = () => {
    const t = r.map(t => /*#__PURE__*/e.createContext(t));
    return function (o) {
      const r = (null == o ? void 0 : o[n]) || t;
      return e.useMemo(() => ({
        ["__scope".concat(n)]: {
          ...o,
          [n]: r
        }
      }), [o, r]);
    };
  };
  return c.scopeName = n, [function (t, o) {
    const c = /*#__PURE__*/e.createContext(o),
      u = r.length;
    function s(t) {
      const {
          scope: o,
          children: r,
          ...s
        } = t,
        i = (null == o ? void 0 : o[n][u]) || c,
        a = e.useMemo(() => s, Object.values(s)); /*#__PURE__*/
      return e.createElement(i.Provider, {
        value: a
      }, r);
    }
    return r = [...r, o], s.displayName = t + "Provider", [s, function (r, s) {
      const i = (null == s ? void 0 : s[n][u]) || c,
        a = e.useContext(i);
      if (a) return a;
      if (void 0 !== o) return o;
      throw new Error("`".concat(r, "` must be used within `").concat(t, "`"));
    }];
  }, t(c, ...o)];
}
function t() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }
  const n = t[0];
  if (1 === t.length) return n;
  const o = () => {
    const o = t.map(e => ({
      useScope: e(),
      scopeName: e.scopeName
    }));
    return function (t) {
      const r = o.reduce((e, _ref) => {
        let {
          useScope: n,
          scopeName: o
        } = _ref;
        return {
          ...e,
          ...n(t)["__scope".concat(o)]
        };
      }, {});
      return e.useMemo(() => ({
        ["__scope".concat(n.scopeName)]: r
      }), [r]);
    };
  };
  return o.scopeName = n.scopeName, o;
}